import ListItemAvatarInitials from './list-item-avatar-initials-left';

export default ListItemAvatarInitials;
